import * as React from 'react';
import * as styles from './styles.scss';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';
import CalendarSearchIcon from './CalendarSearchIcon';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import RSVPStatus from './RSVPStatus';
import { AssetErrorNotFound, AttachmentDocContainer } from 'owa-timestream-asset-sdk';
import { observer } from 'mobx-react-lite';
import type { OwaDate } from 'owa-datetime';

export default observer(function CalendarItemView({
    item,
    itemId,
    popoutPane,
    parsedStart,
    parsedEnd,
    notFound,
    DueDate,
}: {
    item: CalendarItem;
    itemId: string;
    popoutPane: () => void;
    parsedStart: string | OwaDate;
    parsedEnd: string | OwaDate;
    notFound: boolean;
    DueDate?: React.ReactNode;
}) {
    return (
        <div className={styles.calendarItemView} onDoubleClick={popoutPane}>
            <div>{DueDate}</div>
            <div className={styles.timeAndPersonaWrapper}>
                {item?.Organizer?.Mailbox && (
                    <>
                        <CalendarSearchIcon isSmall={true} />
                        <div className={styles.sender}>{item.Organizer.Mailbox.Name}</div>
                    </>
                )}
            </div>
            <h2 className={styles.subject}>
                <a onClick={popoutPane} title={item.Subject}>
                    {item.Subject}
                </a>
            </h2>
            <div className={styles.meetingTime}>
                {formatMeetingTimeSpan(parsedStart, parsedEnd)}
            </div>
            <div className={styles.location}>{item.Location?.DisplayName}</div>
            <RSVPStatus item={item} />
            {!!item.Preview && (
                <div className={styles.preview} title={item.Preview}>
                    {item.Preview}
                </div>
            )}
            {item.HasAttachments && item.Attachments && item.Attachments.length > 0 && (
                <AttachmentDocContainer
                    itemId={itemId}
                    attachments={item.Attachments.map(item => ({
                        Attachment: item,
                    }))}
                    maxResults={2}
                />
            )}
            {notFound && <AssetErrorNotFound />}
        </div>
    );
});
